module.exports = function mapGeolibBoundsToArray(bounds) {
  return [
    [bounds.minLat, bounds.minLng],
    [bounds.maxLat, bounds.maxLng],
  ];
};
